import * as React from 'react';
import {authorize, IWithRouterProps, Overlay, withRouter} from "@athena-portal/components";
import {PluginTemplates} from "../../../../utils/PluginTemplates";
import {lazyInject} from "@athena-portal/core";
import {
    FalconNavigatorHeader,
    ICustomerPortalService,
    Party,
    Policy,
    POLICY_STATUS_MTC,
    ProductsEnum,
    resourcesHelper,
    Types,
    User
} from "@falcon/services";
import FalconFooter from "../../../../components/navigation/FalconFooter";
import FalconHeader from "../../../../components/navigation/FalconHeader";
import {
    AutomaticRenewalCheckboxSection
} from "../../common/payments/paymentDetails/annual/AutomaticRenewalCheckboxSection";
import * as moment from "moment/moment";
import {AccountDetailsBanner} from "../../../../components/banners/AccountDetailsBanner";
import {PersonalDetailsWidget} from "../../../../components/accountDetails/PersonalDetailsWidget";
import {ContactDetailsWidget} from "../../../../components/accountDetails/ContactDetailsWidget";
import {ChangePasswordWidget} from "../../../../components/accountDetails/ChangePasswordWidget";
import {AddressDetailsWidget} from "../../../../components/accountDetails/AddressDetailsWidget";
import {getProductByPolicyNumber} from "../../../../CommonFunctions";
import {AllianzOnlineBadge} from "../../../../components/AllianzOnlineBadge";

interface IPolicySummaryPageParams {
    policyNumber: string;
    [key: string]: string | undefined;
}

interface IState {
    party?: Party,
    user?: User;
    policy?: Policy;
}

@authorize
export class AnnualAccountDetailsPagePlain extends React.Component<IWithRouterProps<IPolicySummaryPageParams>, IState> {

    private pluginTemplates = new PluginTemplates();
    private product: ProductsEnum;

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: IWithRouterProps<IPolicySummaryPageParams>) {
        super(props);

        this.state = {}

        this.product = getProductByPolicyNumber(this.props.params.policyNumber);
    }

    public componentDidMount() {
        {window.scrollTo(0, 0)}

        this.customerPortalService
            .getPolicy(this.props.params.policyNumber)
            .subscribe((policy: Policy) => {
                this.setState({
                    policy
                });
        });

        this.customerPortalService.getProfile().subscribe((output: Party) => {
            const party: Party = output;

            this.setState({
                party
            })
        });

        this.customerPortalService.getUserById().subscribe((user: User) => {
            this.setState({
                user
            });
        });

        this.pluginTemplates.setPageTitle("Your account details");
    }


    public render(): React.ReactNode {
        const loading: boolean = !(this.state.party && this.state.policy && this.state.user);

        if (loading) {
            return  <Overlay show={true}/>;
        } else if (this.state.party && this.state.user && this.state.policy && this.state.policy.annualPolicyInfo) {
            const endDate = moment.utc(this.state.policy.endDate);
            const coverLapsed: boolean = moment.utc().isAfter(endDate);
            const mtaOnEndDateOfPolicy: boolean = moment.utc(endDate).isSame(moment.utc(this.state.policy.annualPolicyInfo.maxFutureMtaDate), 'day');

            return (
                <>
                    <FalconHeader/>
                    <div className="plugin account-details-container">
                        <AllianzOnlineBadge/>
                        <FalconNavigatorHeader
                            back="/dashboard"
                            title="Account details"
                        />
                        <AccountDetailsBanner/>
                        <div className="plugin plugin-panel inner-container inner-content text-center account-details-section">
                            <div className="panel-detail-output-entity account-details-title p-0 icon-container">
                                <div>
                                    <img className="account-details-icon person-icon" alt="make-changes" src={`/${resourcesHelper.THEME}/img/account-details.png`}/>
                                </div>
                            </div>
                            <div>
                                <PersonalDetailsWidget party={this.state.party}/>
                                <div className="w-100">
                                    <img className="mt-3 mb-3 mw-100" src="/img/divider-line.svg" alt="Divider icon" aria-label="Divider line"/>
                                </div>
                                <ContactDetailsWidget party={this.state.party} hasIdp={this.state.party.hasIdp}/>
                                <div className="w-100">
                                    <img className="mt-3 mb-3 mw-100" src="/img/divider-line.svg" alt="Divider icon" aria-label="Divider line"/>
                                </div>
                                <AddressDetailsWidget addressChangeUrl={`/journey/show/product/PropositionWolfMotorInsurance/process/mtaChangeAddress/preset/${this.state.policy?.interaction._id}`}
                                                      allowAddressChange={!this.state.policy?.annualPolicyInfo.hasUnpaidChargebackInvoice}
                                                      futureMta={this.state.policy?.annualPolicyInfo.maxMtaDateReached}
                                                      coverLapsed={(mtaOnEndDateOfPolicy || coverLapsed)}
                                                      fullAddress={this.state.policy?.interaction.policyHolder.address.fullAddress}
                                                      coverCancelled={this.state.policy?.status === POLICY_STATUS_MTC}
                                />
                                <div className="w-100">
                                    <img className="mt-3 mb-3 mw-100" src="/img/divider-line.svg" alt="Divider icon" aria-label="Divider line"/>
                                </div>
                                {this.state.user && !this.state.party.hasIdp && <ChangePasswordWidget/>}
                            </div>
                        </div>
                        <AutomaticRenewalCheckboxSection
                            navigate={this.props.navigate}
                            activeAnnualPolicy={this.state.policy}
                            product={this.product}
                        />
                        {this.pluginTemplates.renderBackLink("Back", false, `/dashboard/`)}
                    </div>
                    <FalconFooter/>
                </>
            )
        }

        return <></>
    }
}

export const AnnualAccountDetailsPage = withRouter<{}, IPolicySummaryPageParams>(AnnualAccountDetailsPagePlain)
